module.exports = __webpack_public_path__ + "static/media/sponsor_banner_sample.12355b97.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/icons/old/sponsor_banner_sample.png
// module id = 589
// module chunks = 0